import { Component } from '@angular/core';

@Component({
  selector: 'payee-autosave',
  templateUrl: './payee-autosave.component.html',
  styleUrls: ['./payee-autosave.component.scss'],
})
export class PayeeAutosaveComponent {}
